<template>
  <div>
    <service-screen-layout :parts="parts">
      <template v-slot:details>
        <VirtualServerDetails 
          :virtualServer="saleDefinition.definition.virtualServer"
          :hostAfrica="true"
          @saveSale="saveSale"
        />
      </template>
      <template v-slot:packagemanagement>
        <VirtualServerPackage 
          :virtualServerPackageNumber="saleDefinition.definition.virtualServer.virtualServerPackageNumber"
          :virtualServerPackage="saleDefinition.definition.virtualServer.virtualServerPackage"
          :packages="packages"
          @saveSale="saveSale"
          @packageChange="packageChange"
        />
      </template>
      <template v-slot:addons>
        <VirtualServerAddOns 
          :virtualServerAddons="saleDefinition.definition.virtualServer.virtualAddons"
          :hostAfrica="true"
          @saveSale="saveSale"
          @createAddon="createAddon"
        />
      </template>
      <template v-slot:licenses>
        <HostAfricaServerLicenses 
          :licenses="saleDefinition.definition.virtualServer.licenses"
          :splaPackages="splaPackages"
          @addLicence="addLicence"
          @editLicense="editLicense"
          @removeLicense="removeLicense"
        />
      </template>
    </service-screen-layout>
    
    <HostAfricaSplaLicenceModal
      ref="splaModal" 
      :modalTitle="selectedSplaLicence.hostafricaSplaPackageNumber ? 'Edit Licence' : 'Add Licence'"
      :splaLicence="selectedSplaLicence"
      :splaPackages="splaPackages"
      @saveSplaLicence="saveSplaLicence"
    /> 
  </div>
</template>

<script>
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";
import HostAfricaSplaLicenceModal from '@/components/Admin/Modals/HostAfricaSplaLicenceModal';

import VirtualServerDetails from "@/components/ObjParts/SingleCaptured/VirtualServerDetails";
import VirtualServerPackage from "@/components/ObjParts/Selected/VirtualServerPackage";
import VirtualServerAddOns from "@/components/ObjParts/OptionalCaptured/VirtualServerAddOns";
import HostAfricaServerLicenses from "@/components/ObjParts/MultipleCaptured/HostAfricaServerLicenses";
import VirtualServerVirtualInternetAccess from "@/components/ObjParts/SingleCaptured/VirtualServerVirtualInternetAccess";

export default {
  components: {
    ServiceScreenLayout,
    HostAfricaSplaLicenceModal,
    VirtualServerDetails,
    VirtualServerPackage,
    VirtualServerAddOns,
    HostAfricaServerLicenses,
    VirtualServerVirtualInternetAccess
  },
  data() {
    return {
      parts: [
        {
          name: "details",
          icon: "fa-solid fa-globe",
          displayName: "Virtual Server",
          permissions: ["*"],
        },
        {
          name: "packagemanagement",
          icon: "fa-solid fa-cube",
          displayName: "Package Management",
          permissions: ["*"],
        },
        {
          name: "addons",
          icon: "fa-solid fa-square-plus",
          displayName: "Add-ons",
          permissions: ["*"],
        },
        {
          name: "licenses",
          icon: "fa-solid fa-id-card",
          displayName: "SPLA",
          permissions: ["*"],
        },
      ],
      saleDefinition: {
        product: {},
        definition: {
          virtualServer: {
            licenses: [],
            virtualServerPackage: {},
            virtualServerPackageNumber: null,
            virtualAddons: {},
          },
        },
        supportingObjs: {
          virtualAddons: {}
        }
      },
      addonTemplate: {},
      packages: [],
      saleNumber: null,
      newLicense: {},
      selectedSplaLicence: {},
      splaPackages: [],
    };
  },
  mounted() {
    this.saleNumber = this.$route.params.saleNumber;
    this.getSale(this.saleNumber);
  },
  methods: {
    getSale: function() {
      const hostUrl = this.$config.aimsAPI;
      const saleNumber = this.saleNumber;

      this.$http.get(`${hostUrl}sales/definition/sale/${saleNumber}`).then(
        (response) => {
          this.saleDefinition = response.data;

          this.splaPackages = this.saleDefinition.selectableOptions.hostAfricaSplaPackage;  
          this.packages = this.saleDefinition.selectableOptions.virtualServerPackage.filter(pkg => pkg.productNumber == this.saleDefinition.product.productNumber); 
        },
        (error) => {
          console.error(error);
          this.showError("Error fetching Sale Definition", error);
        }
      );
    },
    packageChange: function(newValue) {
      return newValue ? this.saleDefinition.definition.virtualServer.virtualServerPackageNumber = newValue : this.saleDefinition.definition.virtualServer.virtualServerPackageNumber;
    },
    createObj: function(data) {            
      const hostUrl = this.$config.aimsAPIv2;
      const saleNumber = this.saleNumber;

      this.$http.post(`${hostUrl}sales/definition/${saleNumber}/obj/create?commit=${true}`, data).then(
        (response) => {
          this.showSuccess("Save Success");
          this.getSale();
        },
        (error) => {
          console.error(error);
          this.showError("Error Saving Object", error);
        }
      )
    },
    saveSale: function() {     
      const hostUrl = this.$config.aimsAPI;
      const saleNumber = this.saleNumber;

      this.$http.put(`${hostUrl}sales/definition/${saleNumber}/update`, this.saleDefinition).then(
          (response) => {
            this.showSuccess("Save Success");
            this.saleDefinition = response.data;
            this.getSale();
          },
          (error) => {
            console.error(error);
            this.showError("Error Saving Sale Definition", error);
          }
        );
    },
    createAddon: function() {     
      const hostUrl = this.$config.aimsAPI;
      const saleNumber = this.saleNumber;

      this.addonTemplate = this.saleDefinition.supportingObjs.virtualAddons;
      this.addonTemplate.virtualServerNumber = this.saleDefinition.definition.virtualServer.virtualServerNumber;

      this.$http.post(`${hostUrl}sales/definition/${saleNumber}/obj/create`, this.addonTemplate).then(
          (response) => {
            this.showSuccess("Addons Created");
            this.getSale();
          },
          (error) => {
            console.error(error);
            this.showError("Error Saving Sale Definition", error);
          }
        );
    },
    saveSplaLicence: function(spla) {
      const hostUrl = this.$config.aimsAPI;
      const saleNumber = this.saleDefinition.sale.saleNumber;

      if (spla.hostAfricaSplaPackageNumber) {
        this.$http.put(`${hostUrl}sales/definition/${saleNumber}/obj/update`, spla).then(
          (response) => {
            this.showSuccess("SPLA Updated successfully");
            this.getSale();
          },
          (error) => {
            console.error(error);
            this.showError("Error Updating SPLA", error);
          }
        );
      }
    },
    addLicence: function() {
      this.selectedSplaLicence = this.saleDefinition.supportingObjs.licenses;
      this.selectedSplaLicence.virtualServerNumber = this.saleDefinition.definition.virtualServer.virtualServerNumber;
      this.selectedSplaLicence.virtualServerPackageNumber = this.saleDefinition.definition.virtualServer.virtualServerPackageNumber;
      this.$refs.splaModal.open();
    },
    editLicense: function(data) {
      this.selectedSplaLicence = data;
      this.$refs.splaModal.open();
    },
    removeLicense: function(data) {
      this.$swal({
          title: "Are you sure you want to delete this Licence?",
          text: data.name,
          type: "warning",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
      }).then((result) => {
          if (result.value) {
            const hostUrl = this.$config.aimsAPI;
            const saleNumber = this.saleDefinition.sale.saleNumber;

            this.$http.post(`${hostUrl}sales/definition/${saleNumber}/obj/delete/`, data).then(
              (response) => {
                this.showSuccess("Delete Success");
                this.getSale();
              },(error) => {
                console.error(error);
                this.showError("Error Removing SPLA", error);
              });
          }
      });
    }
  },
};
</script>
